import * as React from 'react';
import { RenderElementProps } from 'slate-react';

import { TableElement, TableRenderElementProps } from '../../../table/types';
// import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import { AdminTableEditable } from './AdminTable';
import { AdminTableRow } from './AdminTableRow';
import { AdminTableTD } from './AdminTableCell';

// const AdminTableEditable = dynamicEditorComponent(
//   () => import('./AdminTable').then((mod) => mod.AdminTableEditable),
//   {
//     loading: ({ props: { attributes, children } }) => (
//       <div className="admin-table-container">
//         <div {...attributes} aria-hidden>
//           <table>
//             <colgroup contentEditable={false}></colgroup>
//             <tbody>{children}</tbody>
//           </table>
//         </div>
//       </div>
//     ),
//   }
// );
// const AdminTableReadOnly = dynamicEditorComponent(
//   () => import('./AdminTable').then((mod) => mod.AdminTableReadOnly),
//   {
//     loading: ({ props: { attributes, children } }) => (
//       <div className="admin-table-container">
//         <div {...attributes} aria-hidden>
//           <table>
//             <colgroup contentEditable={false}></colgroup>
//             <tbody>{children}</tbody>
//           </table>
//         </div>
//       </div>
//     ),
//   }
// );
//
// const AdminTableRow = dynamicEditorComponent(
//   () => import('./AdminTableRow').then((mod) => mod.AdminTableRow),
//   {
//     loading: ({ props: { attributes, children } }) => <tr {...attributes}>{children}</tr>,
//   }
// );
//
// const AdminTableTD = dynamicEditorComponent(
//   () => import('./AdminTableCell').then((mod) => mod.AdminTableTD),
//   {
//     loading: ({ props: { attributes, children } }) => <td {...attributes}>{children}</td>,
//     dependsOn: AdminTableEditable,
//   }
// );
//
// const TableTDReadOnly = dynamicEditorComponent(
//   () => import('./AdminTableCell').then((mod) => mod.TableTDReadOnly),
//   {
//     loading: ({ props: { attributes, children } }) => <td {...attributes}>{children}</td>,
//     dependsOn: AdminTableReadOnly,
//   }
// );

export const renderAdminTable = (opts: TableRenderElementProps) => (props: RenderElementProps) => {
  const { element } = props;

  if (element.id) {
    switch (element.type) {
      case TableElement.TABLE: {
        return <AdminTableEditable {...props} {...opts} />;
      }
      case TableElement.TR: {
        return <AdminTableRow {...props} {...opts} />;
      }
      case TableElement.TH:
      case TableElement.TD: {
        return <AdminTableTD {...props} {...opts} />;
      }
      default:
    }
  }
  return undefined;
};
